










































































































































import { Vue, Constructor, Component, Watch } from "vue-property-decorator";
import CallBuffer from "./CallBuffer.vue";
import TransferCall from "./TransferCall.vue";
import AddToCall from "./AddToCall.vue";
import Callback from "./Callback.vue";
import SetDisposition from "./SetDisposition.vue";
import { Action, State, Getter } from "vuex-class";
import { duration, objectify } from "@/helpers";
import * as api from "@/lib/api";
import { Features, User } from "@/types";
import moment from "moment";
import { firestore } from "@/configs/firebase";
import logger from "@/configs/logger";
import { checkFeatureAccess } from "@/helpers/permissions";

@Component({
  components: { CallBuffer, TransferCall, AddToCall, SetDisposition, Callback }
})
export default class CallControlBar extends Vue {
  @State("taskAttributes") taskAttributes!: any;
  @Action("muteAgent") muteAgent!: Function;
  @Action("holdCall") holdCall!: Function;
  @Action("requestTakeOver") requestTakeOver!: Function;
  @Action("hangUp") hangUp!: Function;
  @Action("disconnectDevice") disconnectDevice!: Function;
  @Action("cleanUpCall") cleanUpCall!: Function;
  @Getter("availableStatus") availableStatus!: boolean;
  @State("user") user!: User;
  @State("config") config!: any;
  @State("access") userAccess!: any;

  timerRef!: number;
  duration: string = "";
  disableDialBack: boolean = false;
  callStartSeconds: moment.Moment | null = null;

  @Watch("taskAttributes")
  onTaskAtrributesUpdate(val: any, prev: any) {
    if (objectify(val).call_ended && !objectify(prev).call_ended) {
      this.disconnectDevice();
      this.clearTimer();
    }

    if (objectify(val).call_ended && objectify(val).disposition) {
      this.cleanUpCall();
    }
  }

  mounted() {
    this.startTimer();
  }

  updateDuration() {
    if (this.callStartSeconds == null) {
      this.callStartSeconds = moment.unix(firestore.Timestamp.now().seconds);
    }
    const end = moment.unix(firestore.Timestamp.now().seconds);
    const secs = end.diff(this.callStartSeconds, "seconds");
    this.duration = duration(secs);
  }

  startTimer(): void {
    this.timerRef = setInterval(this.updateDuration, 1000);
  }

  endCall() {
    this.clearTimer();
    this.hangUp();
  }

  async dialBack() {
    try {
      this.disableDialBack = true;
      await api.dialBack(`task_attribute/${this.taskAttributes.id}`);
    } catch (err) {
      logger("error", "dial back error", err);
      this.$toasted.error("Dial back Failed").goAway(2000);
    }
  }

  clearTimer(): void {
    this.duration = "";
    window.clearInterval(this.timerRef);
  }

  beforeDestroy(): void {
    this.clearTimer();
  }

  handleCallHold(): void {
    this.holdCall(!this.attributes.lead_hold);
  }

  handleMuteAgent(): void {
    this.muteAgent(!this.attributes.agent_muted);
  }

  handleRequestTakeOver(): void {
    this.requestTakeOver(!this.attributes.request_take_over);
  }

  get qualifiedInfo(): string {
    let transfer_from_user_group: string = this.attributes
      .transfer_from_user_group;
    if (transfer_from_user_group) {
      if (transfer_from_user_group == "fronter_t2") {
        return "Qualified";
      } else if (transfer_from_user_group.startsWith("fronter_t3")) {
        return "Semi-Qualified";
      }
    }
    return "";
  }

  get callDirection(): string {
    const source = this.attributes.task_creation_source || "";
    return source.replace(/_/g, " ");
  }

  get attributes(): any {
    return this.taskAttributes || {};
  }

  get controlActions(): any[] {
    const color = "secondary";
    const onHold = this.attributes.lead_hold;
    const muted = this.attributes.agent_muted;
    const canRquestTakeover = checkFeatureAccess(Features.RequestTakeover, {
      access: this.userAccess,
      roles: this.user.roles
    });

    let controls = [
      {
        type: "hold",
        icon: "mdi-pause",
        color: onHold ? "red" : color,
        onPress: this.handleCallHold,
        tooltip: onHold ? "on hold" : "hold"
      },
      {
        type: "mute",
        icon: "mdi-microphone-off",
        color: muted ? "red" : color,
        onPress: this.handleMuteAgent,
        tooltip: muted ? "muted" : "mute"
      }
    ];

    if (!this.attributes.taken_over_by_email && canRquestTakeover) {
      controls.push({
        type: "request takeover",
        icon: "mdi-account-switch",
        color: this.attributes.request_take_over ? "red" : color,
        onPress: this.handleRequestTakeOver,
        tooltip: "request takeover"
      });
    }
    return controls;
  }
}
